import { Skeleton } from '@r/components/ui/skeleton.tsx';
import { Card, CardContent, CardHeader } from '@ui/card.tsx';

const ShopProductsSidebarSkeleton = () => (
  <Card className="sticky left-0 z-10 border-none top-5 h-fit">
    <CardHeader className="flex flex-row flex-nowrap items-start space-x-2.5 space-y-0">
      <div className="p-2">
        <Skeleton className="w-6 h-6 rounded-full" />
      </div>
      <Skeleton className="w-48 h-8" />
    </CardHeader>

    <CardContent>
      <div className="space-y-4">
        <Skeleton className="w-32 h-6" />
        <Skeleton className="w-full h-10" />
      </div>
    </CardContent>
  </Card>
);

export { ShopProductsSidebarSkeleton };
